export var MEMBER_TYPE;
(function (MEMBER_TYPE) {
    MEMBER_TYPE["ORG"] = "ORG";
    MEMBER_TYPE["ACC"] = "ACC";
    MEMBER_TYPE["DEP"] = "DEP";
})(MEMBER_TYPE || (MEMBER_TYPE = {}));
export var ROLE_TYPE;
(function (ROLE_TYPE) {
    ROLE_TYPE["ADMIN"] = "ADMIN";
    ROLE_TYPE["DEP_MANAGER"] = "DEP_MANAGER";
    ROLE_TYPE["STUFF"] = "STUFF";
    ROLE_TYPE["ORG"] = "ORG";
})(ROLE_TYPE || (ROLE_TYPE = {}));
